module.exports = __webpack_public_path__ + "img/apeiron-logo.d85d5f5b.png";